import { render } from "./ProjectsOverview.vue?vue&type=template&id=657410fd&scoped=true&ts=true"
import script from "./ProjectsOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectsOverview.vue?vue&type=script&lang=ts"

import "./ProjectsOverview.vue?vue&type=style&index=0&id=657410fd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657410fd"]])

export default __exports__